export default __webpack_public_path__ + "static/media/500-internal-server-error-bro.e8a5ce27.svg";